import anErrorOccurredPleaseTryAgainLater from '@util/labels/anErrorOccurredPleaseTryAgainLater'
import { get } from 'lodash-es'

export const toFormErrorResponse = <TFormData>(data: unknown): TFormErrorResponse<TFormData> => {
    const errors = get(data, 'errors', {})
    const namedErrors = get(data, 'namedErrors', {})

    return {
        message: get(data, 'message', anErrorOccurredPleaseTryAgainLater),
        errors: Object.keys(errors).reduce(
            (acc, key) => ({ ...acc, [key]: errors[key].message }),
            {} as TFormErrorResponse<TFormData>['errors']
        ),
        namedErrors: Object.keys(namedErrors).reduce(
            (acc, key) => ({ ...acc, [key]: namedErrors[key].message }),
            {} as TFormErrorResponse<TFormData>['namedErrors']
        ),
    }
}
